export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 text-white py-16 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <span className="text-xl font-bold">Daniel Lozano</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              高インパクトなビジュアル戦略とファンダム美学を専門とするVTuberブランディング＆2Dアセットデザイナー。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">クイックリンク</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('works-section')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-sm text-gray-400 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  作品
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('about-section')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-sm text-gray-400 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  プロフィール
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-sm text-gray-400 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">つながる</h4>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/in/daniellozanomunera/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-pink-500 rounded-lg transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://www.behance.net/daniellozano25"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-pink-500 rounded-lg transition-all cursor-pointer"
              >
                <i className="ri-behance-fill text-lg"></i>
              </a>
              <a
                href="mailto:daniel@example.com"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-pink-500 rounded-lg transition-all cursor-pointer"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © 2024 Daniel Lozano. All rights reserved.
          </p>
          
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-gray-400 hover:text-pink-400 transition-colors cursor-pointer">
              プライバシーポリシー
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-pink-400 transition-colors cursor-pointer">
              利用規約
            </a>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-pink-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-gradient-to-br from-pink-500 to-purple-600 text-white rounded-full shadow-lg hover:scale-110 transition-transform duration-300 z-50 flex items-center justify-center cursor-pointer"
        aria-label="トップに戻る"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </footer>
  );
}